import React from "react";
import InputText from "../../../common/Input/InputText";

const PatientDetails = ({medicalCertificate, handleChange, medicalCertificateFormData}) => {
    return (
        <>
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">Patient Details</h4>
                    <div className="row">
                        <div className="col-xl-4">
                            <p>Name</p>
                            <p className="border p-1 ps-3">{medicalCertificate?.patientId?.userId?.name || "N/A"}</p>
                        </div>
                        <div className="col-xl-4">
                            <p>Age</p>
                            <p className="border p-1 ps-3">{`${medicalCertificate?.patientId?.userId?.age?.year} Y` || `${medicalCertificate?.patientId?.userId?.age?.month} M` || `${medicalCertificate?.patientId?.userId?.age?.day}`}</p>
                        </div>
                        <div className="col-xl-4">
                            <p>DOB</p>
                            <p className="border p-1 ps-3">{medicalCertificate?.appointmentId || "N/A"}</p>
                        </div>
                        <div className="col-xl-4">
                            <p>Gender</p>
                            <p className="border p-1 ps-3">{medicalCertificate?.patientId?.userId?.gender || "N/A"}</p>
                        </div>
                        <div className="col-xl-4">
                            <p>Referred By</p>
                            <p className="border p-1 ps-3">{medicalCertificate?.referredBy?.name || "N/A"}</p>
                        </div>
                        <div className="col-xl-4">
                            <p>Applied Country</p>
                            <p className="border p-1 ps-3">{medicalCertificate?.serviceMode || "India"}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-xl-4">
                            <InputText
                                name="passportNumber"
                                label="Passport Number"
                                value={medicalCertificate?.patientId?.userId?.passport}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="nationality"
                                label="Nationality"
                                value={medicalCertificateFormData?.nationality}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="religion"
                                label="Religion"
                                value={medicalCertificateFormData?.religion}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="maritalStatus"
                                label="Marital Status"
                                value={medicalCertificateFormData?.maritalStatus}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="postAppliedFor"
                                label="Post Applied For"
                                value={medicalCertificateFormData?.postAppliedFor}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="projectName"
                                label="Project Name"
                                value={medicalCertificateFormData?.projectName}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="height"
                                label="Height (in cm)"
                                value={medicalCertificateFormData?.height}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="weight"
                                label="Weight (in Kg)"
                                value={medicalCertificateFormData?.weight}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="BMI"
                                label="BMI( in Kg/m2)"
                                value={medicalCertificateFormData?.BMI}
                                // onChange={handleChange}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PatientDetails;